import React, { useEffect, useState, FC } from "react";
import style from "./index.module.scss";
import "./common.css";
import qs from 'qs';
import { Anchor , Table} from 'antd';

const { Link } = Anchor;
export interface IAppProps {
  apiHost: string;
  loginHost: string;
}
let _host = "";
let _loginHost = "";

const columns = [
  {
    title: '应用类型',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '简介',
    dataIndex: 'desc',
    key: 'desc',
  }
];

//能力介绍
const ImgTop: FC<any> = (props) => {
  const { abilityList } = props;
  return (
    <div id="topImgWrap">
      <div id={style.topImgWrap}>
        <div key={abilityList.title} className={style.bacImgWrap} style={{ backgroundImage: 'url(//storage.360buyimg.com/hishop-images/jos-home-img/top.png)' }}>
          <div className={style.mainContentWrap}>
            <div className={style.iconLink}><img src={abilityList.iconLink} alt='' /></div>
            <div className={style.right}>
              <div className={style.text}>{abilityList.abilityName}</div>
              <div className={style.subTitle}>{abilityList.description}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

//能力详情
const PopularAbility: FC<any> = (props) => {
  const { abilityList } = props;
  return (
    <div id='CapabilityDetails'>
      <div id={style.CapabilityDetails}>
        <div className={style.title}><span className={style.popularAbilitySpan}></span>能力详情</div>
        <div className={style.txt} style={{marginTop: '24px'}}>
          <div className="ck ck-content" dangerouslySetInnerHTML={{ __html: abilityList.content }} />
        </div>
      </div>
    </div>
  );
};

//能力获取
const SelectionAbility: FC<any> = (props) => {
  const { abilityTableList } = props;
  return (
    <div id='CapabilityAcquisition'>
      <div id={style.CapabilityAcquisition}>
        <div className={style.title}><span className={style.popularAbilitySpan}></span>能力获取</div>
        <div className={style.Acquisitiontxt}>
          能力以权限包的形式绑定在特定应用类型下。
          <a href="https://jos-console.jd.com/index#/app/createApp/Types" target="_blank">前往控制台创建应用获取能力</a>
        </div>
        <div className={style.AcquisitionTable}>
          <Table dataSource={abilityTableList} columns={columns} 
            pagination={false}
          />
        </div>
      </div>
    </div>
  );
}

//相关接口
const CharacteristicAbility: FC<any> = (props) => {
  const { abilityInterfaceList, abilityList, _host,baseUrl } = props;
  return (
    <div id='CapabilityAcquisitionTwo'>
      <div id={style.CapabilityAcquisitionTwo}>
        <div className={style.title}><span className={style.popularAbilitySpan}></span>相关接口</div>
        <div className={style.AcquisitiontxtTwo}>
          所属权限包: 
          <a href={`https://jos.jd.com/apilist?apiGroupId=${abilityList.authPackId}&apiGroupName=${abilityList.authPackName}`} target="_blank">{abilityList.authPackName}</a>
        </div>
        <div className={style.RelatedInterface}>
          {
            abilityInterfaceList.map((item: any,index: any)=>{
              return (
                <div>
                  <div className={style.RelatedIntertxt}><a href={`
                  http://jos.jd.com/apilist?apiGroupId=${item.apiGroupId}&apiId=${item.id}&apiName=${item.apiName}
                  `} target="_blank" >{item.apiName} ({item.znName}) <span className={style.RelatedInterfaceSpan} style={{ backgroundImage: `url(${baseUrl}detail-arrow.png)`}}></span> </a></div>
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  );
}

//常见问题
const CommonProblem: FC<any> = (props) => {
  const { abilityQuestionsList, _host, baseUrl } = props;
  return (
    <div id="CommonProblem">
      <div id={style.CommonProblem}>
        <div className={style.title}><span className={style.popularAbilitySpan}></span>常见问题</div>
        <div className={style.CommonProblemtxt}>
          {
            abilityQuestionsList.map((item: any)=>{
              return (
                <div className={style.box}>
                  <span className={style.CommonProblemSpan} style={{ backgroundImage: `url(${baseUrl}question.png)`}}></span>
                  <a href={item.questionLink} target="_blank">{item.question}？</a>
                </div>
                )
            })
          }
        </div>
      </div>
    </div>
  );
}
// 左侧锚点
const LeftAnchor: FC<any> = (props) => {
  return (
    <Anchor onChange={AnchorChange} onClick={handleAnchorClick}>
      <Link href="#topImgWrap" title="能力介绍" />
      <Link href="#CapabilityDetails" title="能力详情" />
      <Link href="#CapabilityAcquisition" title="能力获取"></Link>
      <Link href="#CapabilityAcquisitionTwo" title="相关接口" />
      <Link href="#CommonProblem" title="常见问题" />
    </Anchor>
  );
}

const AnchorChange =(link:any) =>{
  console.log(link)
}

const handleAnchorClick = (e: any) => {
  // e.preventDefault();
};

const App: React.FC<IAppProps> = (props) => {
  const { apiHost, loginHost } = props;
  const baseUrl = "//storage.360buyimg.com/hishop-images/jos-home-img/";
  _host = apiHost;
  _loginHost = loginHost;

  const [abilityId, setAbilityId ] = useState([]) //id

  const [ abilityList, setAbilityList] = useState([]) //所有数据

  const [ abilityTableList, setAbilityTableList ] = useState([]) //列表数据

  const [ abilityInterfaceList, setAbilityInterfaceList] = useState([]) //相关接口

  const [abilityQuestionsList,setAbilityQuestionsList] = useState([]) //常见问题

  const fetchList = (abilityId: any) => {
    fetch(_host + "/ability/detail?abilityId="+`${abilityId ? abilityId : '13' }`, {
      method: "POST",
      credentials: "include",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        const { code, data, success } = res;
      console.log(data);
      if(code === 100000 && success){
        setAbilityList(data);
        setAbilityTableList(data.appTypes)
        setAbilityInterfaceList(data.apiVos)
        setAbilityQuestionsList(data.questions)
        }
      })
      .catch(function () {
        console.log("失败了！！！");
      })
 };

  useEffect(() => {
    const param: any = qs.parse(location.href.split('?')[1]).abilityId;
    setAbilityId(param);
    fetchList(param);
  }, [])

  return (
    <div className={style.commonToolsWrap}>
      {/* 顶部大图 */}
      <ImgTop abilityList={abilityList}></ImgTop>
      <div className={style.popularAbilityWrap}>
        <div className={style.popularAvilityLeft}>
          <LeftAnchor/>
        </div>
        <div className={style.popularAvilityRight}>
          <PopularAbility abilityList={abilityList}/>
          <SelectionAbility abilityTableList={abilityTableList}/>
          <CharacteristicAbility abilityInterfaceList={abilityInterfaceList} abilityList={abilityList} _host={_host} baseUrl={baseUrl}/>
          <CommonProblem abilityQuestionsList={abilityQuestionsList} _host={_host} baseUrl={baseUrl}/>
        </div>
      </div>
    </div>
  );
};

export default App;
